import { useState, useEffect } from 'react';
import useSessionContext from '../data/queryHooks/useSessionContext';

const useHasDefaultLocation = () => {
	const { isLoading, flows } = useSessionContext();

	const [hasDefaultLocation, setHasDefaultLocation] = useState(true);

	useEffect(() => {
		if (!isLoading) {
			if (flows.findIndex(item => item?.flow === 2) > -1) {
				setHasDefaultLocation(false);
			}
		}
	}, [isLoading]);

	return {
		hasDefaultLocation,
	};
};

export default useHasDefaultLocation;
